import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import T from '../../../Locale';
import Input from '../../../Components/ComponentInput';
const AdditionalFieldsCompany = ({ validated, hasAdditionalData, getAdditionalInfo, setAdditionalInfo }) => {
    const labels = {
        cvr: T.translate('values.company.cvr'),
        number: T.translate('values.company.number')
    };
    return (_jsxs("div", { children: [_jsx("h5", { children: labels.cvr }), _jsx("p", { children: T.translate('values.company.cvrDescription') }), _jsx(Input, { defaultValue: getAdditionalInfo('cvr'), onKeyPress: (value) => setAdditionalInfo('cvr', labels.cvr, value), onChange: (value) => setAdditionalInfo('cvr', labels.cvr, value), error: validated && !hasAdditionalData('cvr'), required: true }), _jsx("h5", { children: labels.number }), _jsx("p", { children: T.translate('values.company.numberDescription') }), _jsx(Input, { defaultValue: getAdditionalInfo('number'), onKeyPress: (value) => setAdditionalInfo('number', labels.number, value), onChange: (value) => setAdditionalInfo('number', labels.number, value), error: validated && !hasAdditionalData('number') })] }));
};
AdditionalFieldsCompany.propTypes = {
    validated: PropTypes.bool.isRequired,
    hasAdditionalData: PropTypes.func.isRequired,
    getAdditionalInfo: PropTypes.func.isRequired,
    setAdditionalInfo: PropTypes.func.isRequired
};
export default AdditionalFieldsCompany;
